import { ChatCircleIcon } from '@phosphor-icons/react'
import { useHelpBotContext } from '../../../../../../../context/HelpBotContext'
import { ScoopTooltip } from '../../../../../../ui'
import styles from './AskAboutButton.module.scss'

export const AskAboutButton = ({ entity, context, finding, runPath }) => {
    const { sendPrompt, isPending } = useHelpBotContext()

    const handleClick = (e) => {
        e.stopPropagation()

        const parts = [
            "I'm looking at an investigation report.",
            entity ? `Entity: ${entity}` : null,
            context ? `Context: ${context}` : null,
            finding ? `Finding: "${finding}"` : null,
            runPath ? `Run: ${runPath}` : null,
            'Help me understand this finding and what actions to consider.',
        ]

        sendPrompt(parts.filter(Boolean).join('\n'))
    }

    return (
        <ScoopTooltip title="Ask about this">
            <button
                className={styles.askButton}
                onClick={handleClick}
                disabled={isPending}
                type="button"
            >
                <ChatCircleIcon size={14} />
            </button>
        </ScoopTooltip>
    )
}
